(function() {
	'use strict';

	angular.module('paymentRates').config(config);

	function config($stateProvider) {
		$stateProvider.state('paymentRates', {
			url : '/payment-rates',
			views : {
				'paymentRatesView' : {
					templateUrl : 'payment-rates/views/payment-rates.tpl.html',
					controller : 'PaymentRatesCtrl',
					controllerAs : 'paymentRates'
				}
			}
		});
	}
}());
